/* eslint-disable no-underscore-dangle */
const YM_SCRIPT_SRC = 'https://mc.yandex.ru/metrika/tag.js';

function ensureYmStub() {
    if (typeof window === 'undefined') return;
    if (typeof window.ym === 'function') return;

    // Standard YM stub to queue calls until tag.js loads.
    // eslint-disable-next-line func-names
    const ymStub = function () {
        // eslint-disable-next-line prefer-rest-params
        (ymStub.a = ymStub.a || []).push(arguments);
    };
    ymStub.l = Date.now();
    window.ym = ymStub;
}

function loadScriptOnce(src) {
    if (typeof window === 'undefined') return Promise.resolve(false);

    window.__eeAsyncScripts = window.__eeAsyncScripts || {};
    if (window.__eeAsyncScripts[src]) return window.__eeAsyncScripts[src];

    window.__eeAsyncScripts[src] = new Promise((resolve) => {
        const existing = document.querySelector(`script[src="${src}"]`);
        if (existing) {
            resolve(true);
            return;
        }

        const s = document.createElement('script');
        s.async = true;
        s.src = src;
        s.onload = () => resolve(true);
        s.onerror = () => resolve(false);
        document.head.appendChild(s);
    });

    return window.__eeAsyncScripts[src];
}

function initMetrika(counterId) {
    if (typeof window === 'undefined') return;
    if (!counterId) return;
    ensureYmStub();
    if (typeof window.ym !== 'function') return;

    // Prevent duplicate init for the same counter
    window.__eeYmInited = window.__eeYmInited || {};
    if (window.__eeYmInited[counterId]) return;
    window.__eeYmInited[counterId] = true;

    // eslint-disable-next-line no-console
    // console.log('[YM] init', { counterId });
    window.ym(counterId, 'init', {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
    });
}

export class YandexMetrikaAnalyticsClient {
    constructor() {
        this.clientName = 'YandexMetrikaAnalytics';
        this.counterId = 34904255;

        this._ready = Promise.resolve(false);
        this._init();
    }

    _init() {
        if (typeof window === 'undefined') return;
        if (!this.counterId) return;

        ensureYmStub();
        this._ready = loadScriptOnce(YM_SCRIPT_SRC).then((ok) => {
            // eslint-disable-next-line no-console
            // console.log('[YM] script loaded', { ok, src: YM_SCRIPT_SRC });
            if (!ok) return false;
            initMetrika(this.counterId);
            return true;
        });
    }

    emit(data) {
        const { event, ...params } = data || {};
        if (!event) return;
        if (!this.counterId) return;

        // Fire and forget; do not block UI.
        this._ready.then(() => {
            ensureYmStub();
            if (typeof window.ym !== 'function') {
                // eslint-disable-next-line no-console
                // console.log('[YM] ym not available');
                return;
            }

            if (event === 'reachGoal') {
                const { goal, ...goalParams } = params;
                if (!goal) return;
                // eslint-disable-next-line no-console
                // console.log('[YM] reachGoal', { counterId: this.counterId, goal, goalParams });
                window.ym(this.counterId, 'reachGoal', goal, goalParams);
                return;
            }

            if (event === 'userParams') {
                const { ...goalParams } = params;
                // eslint-disable-next-line no-console
                // console.log('[YM] userParams', { counterId: this.counterId, goalParams });
                window.ym(this.counterId, 'userParams', goalParams);
                window.ym(this.counterId, 'setUserID', goalParams?.UserID);
                return;
            }

            if (event === 'hit') {
                const {
                    url, title, referer, ...hitParams
                } = params;
                if (!url) return;
                // eslint-disable-next-line no-console
                // console.log('[YM] hit', {
                //     counterId: this.counterId,
                //     url,
                //     title,
                //     referer,
                //     hitParams,
                // });
                window.ym(this.counterId, 'hit', url, {
                    ...(title ? { title } : null),
                    ...(referer ? { referer } : null),
                    ...hitParams,
                });
            }
        });
    }
}

